import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "help"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "ShareMentors ヘルプ", -1);
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = { class: "anc" };
const _hoisted_7 = {
    key: 0,
    class: "h_list"
};
import { ref, onMounted } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import { AuthRole, UserType, HelpType } from '@util/Consts';
export default /*#__PURE__*/ _defineComponent({
    __name: 'help',
    props: {
        common: null,
        helps: null
    },
    setup(__props) {
        const props = __props;
        const helpTag = ref(UserType.QUESTIONER); // Mentor:メンター情報 それ以外:相談者情報（Questioner, Admin, null）
        const getRoute = (id) => {
            return route('help.show', { id: id });
        };
        onMounted(() => {
            if (props.common.role === AuthRole.MENTOR) {
                helpTag.value = UserType.MENTOR;
            }
            else {
                helpTag.value = UserType.QUESTIONER;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("ul", _hoisted_6, [
                                    _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                            class: _normalizeClass({ active: helpTag.value === _unref(UserType).QUESTIONER }),
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (helpTag.value = _unref(UserType).QUESTIONER), ["prevent"])),
                                            style: { "cursor": "pointer" }
                                        }, " 相談者 ", 2)
                                    ]),
                                    _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                            class: _normalizeClass({ active: helpTag.value === _unref(UserType).MENTOR }),
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (helpTag.value = _unref(UserType).MENTOR), ["prevent"])),
                                            style: { "cursor": "pointer" }
                                        }, " メンター ", 2)
                                    ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.helps, (category, categoryIndex) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (helpTag.value == category.type || category.type == _unref(HelpType).COMMON)
                                            ? (_openBlock(), _createElementBlock("dl", _hoisted_7, [
                                                _createElementVNode("dt", null, _toDisplayString(category.name), 1),
                                                _createElementVNode("dd", null, [
                                                    _createElementVNode("ul", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.data, (data, dataIndex) => {
                                                            return (_openBlock(), _createElementBlock("li", null, [
                                                                _createVNode(_unref(Link), {
                                                                    href: getRoute(data.id)
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(data.name), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["href"])
                                                            ]));
                                                        }), 256))
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 256))
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
